<template>
  <div class="account-info-wrapper">
    <header-title :title="$t('yourInformation.accountInfo')" class="title" />
    <div class="input-container">
      <div class="row-inputForm">
        <label for="name" class="label">{{ $t("yourInformation.name") }}</label>
        <input
          type="text"
          v-model="nickname"
          :class="{ invalid: errors.has('nickname') }"
          v-validate="'required'"
          name="nickname"
          :placeholder="$t('yourInformation.putName')"
          class="form-control name"
        />
      </div>
      <div class="row-inputForm">
        <label for class="label">{{ $t("yourInformation.gender") }}</label>
        <div class="radio-container">
          <div class="radio-content">
            <input
              type="radio"
              name="gender"
              value="1"
              v-model.number="gender"
            />
            <label for class="label-gender">{{
              $t("yourInformation.men")
            }}</label>
          </div>

          <div>
            <input
              type="radio"
              name="gender"
              value="2"
              v-model.number="gender"
            />
            <label for class="label-gender">{{
              $t("yourInformation.women")
            }}</label>
          </div>
        </div>
      </div>

      <div class="row-inputForm">
        <label for="height" class="label">{{
          $t("yourInformation.height")
        }}</label>
        <input
          type="number"
          name="height"
          v-model.number="height"
          class="form-control"
          v-validate="'required|between:0,300'"
          :class="{ invalid: errors.has('height') }"
        />
      </div>

      <next-button
        :label="$t('common.register')"
        :disabled="isDisabled"
        @click.prevent="onSubmit"
      />
    </div>
  </div>
</template>

<script>
import HeaderTitle from "../design/HeaderTitleSlot";
import NextButton from "../components/atoms/NextButton";

export default {
  name: "userInfo",
  props: {
    source: String
  },
  components: {
    HeaderTitle,
    NextButton
  },
  data() {
    return {
      nickname: "",
      gender: null,
      height: null
    };
  },
  created() {
    // Firebaseから、ユーザのデータを全て取得
    this.fetchUserFromFirebase(this.$store.state.auth.user.uid);
  },
  computed: {
    // TODO ウォッチャに変更する(dirty以外での条件づけに変える)
    isDisabled: function() {
      return Object.keys(this.fields).some(key => this.fields[key].invalid);
    }
  },
  methods: {
    // FireBaseからユーザ情報を取得
    async fetchUserFromFirebase() {
      await this.$store.dispatch(
        "users/fetchUserFromFirebase",
        this.$store.state.auth.user.uid
      );
      this.nickname = this.$store.state.users.nickname;
      this.gender = this.$store.state.users.gender;
      this.height = this.$store.state.users.height;
    },
    // FireBaseに設定したデータを送信
    async sendUserToFirebase() {
      await this.$store.dispatch("users/sendUserToFirebase", {
        uid: this.$store.state.auth.user.uid,
        form: {
          nickname: this.nickname,
          gender: this.gender,
          height: this.height
        }
      });
    },
    async onSubmit() {
      await this.sendUserToFirebase();
      alert(this.$t("yourInformation.saveAccount"));
      if (this.source === "profile") {
        this.$router.push({ name: "notebook" });
      } else {
        this.$router.push({ name: "login" });
      }
    }
  }
};
</script>

<style scoped>
/* 入力フォーム外周コンテナ */
.account-info-wrapper {
  align-content: center;
  width: 65vw;
  margin: 0 auto;
}
.input-container {
  margin: auto;
  border: 1px solid #e7e6e7;
  padding: 40px;
  border-radius: 10px;
  margin-top: 20px;
}

.form-control {
  border-radius: 5px;
  border: 1px solid #ced4da;
  padding: 5px;
  height: 30px;
  font-size: calc(112.5% + 0.25vw);
}

.row-inputForm {
  display: grid;
  align-items: center;
  gap: 20px;
  margin-bottom: 40px;
  grid-template-columns: 1fr 4.5fr;
}
.radio-container {
  display: flex;
}
.radio-content {
  margin-right: 40px;
}
/* エラー表記用 */
.invalid {
  border-color: red;
}
@media screen and (max-width: 599px) {
}
@media screen and (min-width: 600px) and (max-width: 959px) {
  .input-container {
    margin-top: 40px;
  }
}
@media screen and (min-width: 960px) {
  .input-container {
    margin-top: 40px;
  }
}
</style>
